import { TemplateConfig } from '@rxweb/grid';
import { PipeConstants } from 'src/app/components/shared/constant/commonConstants';


export const ACTION_PROJECTLIST_GRID_TEMPLATE: TemplateConfig = {
    div: {
        class: 'formAction list-unstyled mb-0'.split(' '),
        childrens: [{
            a: {
                class: 'gridEditbtn'.split(' '),
                authorize: 'put',
                event: {
                    click: 'onEdit'
                },
                childrens: [{
                    a: {                        
                        childrens: [{
                            i: { class: 'feather icon-edit'.split(' ') }
                        }],
                    }
                }]
            }

        },
        {
            a: {
                class: 'gridDeletebtn'.split(' '),
                authorize: 'delete',
                event: {
                    click: 'onDelete'
                },
                childrens: [{
                    a: {
                        childrens: [{
                            i: { class: 'feather icon-trash-2'.split(' ') }
                        }],
                    }
                }]
            }

        },
        {
            a: {
                class: 'gridPinkbtn'.split(' '),
                authorize:"get",
                event: {
                    click: 'onLink'
                },
                childrens: [{
                    a: {
                        childrens: [{
                            i: { class: 'feather icon-check-square'.split(' ') }
                        }],
                    }
                }]
            }
        }
        ]
    }
};
